import React, { useEffect, useState} from 'react';
import {Vector3} from "three";
import Button from '../layout/Button';
import {IconFillStyles, GizmoMoveIcon} from '../Iconset';
import Engine from '../../classes/Engine';
import {TooltipKeys} from "../tooltips/TooltipKeys";
import {CustomEventTypes} from '../../globals';
import {TransformControlsMouseCallback, TransformControlsMoveCallback} from "../../classes/TransformControls";
import useEventListener from '../reactUtils/useEventListener';


interface GizmoControllerPropertyProps
{
	value: any,
	gizmoGetInitialOffset?: () => Vector3,
	gizmoControlMouseDownCallback?: TransformControlsMouseCallback,
	gizmoControlMouseMoveCallback?: TransformControlsMoveCallback,
	gizmoControlMouseUpCallback?: TransformControlsMouseCallback,
	onCommitCallback?: TransformControlsMouseCallback,
	gizmoControlTooltipOverride?: string,
	cellclass?: string
}

export default function GizmoControllerProperty(props: GizmoControllerPropertyProps)
{
	const [gizmoFreeMoveModeEnabled, setGizmoFreeMoveModeEnabled] = useState(false);
	useEventListener(CustomEventTypes.onGizmoFreeMoveModeChanged, onGizmoFreeMoveChanged, document);

	useEffect(() =>
	{
		//the property value changes during gizmo free move mode, but the change was not triggered by the gizmo itself. need to update things accordingly
		if (gizmoFreeMoveModeEnabled && !Engine.getInstance().getGizmoManager().isBusy())
		{
			toggleGizmoControlMode(true);
		}
	}, [props.value]);

	function toggleGizmoControlMode(enableMode)
	{
		if (enableMode)
		{
			const initialGizmoOffset = props.gizmoGetInitialOffset ? props.gizmoGetInitialOffset() : undefined;
			Engine.getInstance().getGizmoManager().enterFreeMoveMode(props.gizmoControlMouseDownCallback, props.gizmoControlMouseMoveCallback, props.gizmoControlMouseUpCallback ?? props.onCommitCallback, initialGizmoOffset);
		}
		else
		{
			Engine.getInstance().getGizmoManager().exitFreeMoveMode();
		}

		if (Engine.getInstance().getGizmoManager().getFreeMoveMode())
		{
			setGizmoFreeMoveModeEnabled(true);
		}
	}

	function onGizmoFreeMoveChanged()
	{
		if (!Engine.getInstance().getGizmoManager().getFreeMoveMode() && gizmoFreeMoveModeEnabled)
		{
			setGizmoFreeMoveModeEnabled(false);
		}
	}

	return (
		<Button iconRenderer={<GizmoMoveIcon scale={0.75}
			fillStyle={gizmoFreeMoveModeEnabled ? IconFillStyles.dark : IconFillStyles.default}/>}
		data-name={"gizmo-type-translate"}
		className={["buttonGroupButton", gizmoFreeMoveModeEnabled ? "current" : ""].join(' ')}
		category={"Toolbar"}
		onClick={() =>
		{
			toggleGizmoControlMode(!gizmoFreeMoveModeEnabled);
		}}
		tooltip={props.gizmoControlTooltipOverride ?? TooltipKeys.GizmoFreeMoveMode}
		/>
	);
}

